import React, { Component } from 'react';
import './result.css';

class Result extends Component {
    render() {
        const result = this.props.result;

        let noteDisplay = null;
        if (result.note) {
            noteDisplay = (
                <div className="result-item">
                    <div className="result-label">Navigational Note</div>
                    <div className="result-info">{result.note}</div>
                </div>
            );
        }

        let changeDisplay = null;
        if (result.change) {
            changeDisplay = (
                <div className="result-item">
                    <div className="result-label">Change</div>
                    <div className="result-info">{result.change}</div>
                </div>
            );
        }

        return (
            <div>
                <div className="list">
                    <div>
                        <div className="result">
                            <div className="result-item">
                                <div className="result-label">MedDRA Code</div>
                                <div className="result-info">{result.meddra_code}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">SOC</div>
                                <div className="result-info">{result.meddra_soc}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Term</div>
                                <div className="result-info">{result.ctcae_term}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Definition</div>
                                <div className="result-info">{result.definition}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 1</div>
                                <div className="result-info">{result.grade_1}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 2</div>
                                <div className="result-info">{result.grade_2}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 3</div>
                                <div className="result-info">{result.grade_3}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 4</div>
                                <div className="result-info">{result.grade_4}</div>
                            </div>
                            <div className="result-item">
                                <div className="result-label">Grade 5</div>
                                <div className="result-info">{result.grade_5}</div>
                            </div>

                            {noteDisplay}
                            {changeDisplay}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Result;



// WEBPACK FOOTER //
// ./src/component/ctcae6/result/result.js